import { api } from "./client";

export interface SignupStatusResponse {
  status: string;
  role?: string;
  email?: string;
  customer?: {
    id: string;
    name: string;
    email: string;
    status: string;
    stacuityCustomerId?: string;
    createdAt: string;
  };
}

export const signupApi = {
  /** Check the current user's onboarding status. */
  getStatus: () =>
    api.get<{ data: SignupStatusResponse }>("/signup/status"),

  /** Register a new customer account (self-service). */
  register: (data: { companyName: string; acceptedTerms: boolean }) =>
    api.post<{ data: SignupStatusResponse }>("/signup", data),
};
